import { Button, FormLayout, PasswordInput, SubmitButton, TextInput } from '@expressable/syntax-ds';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type Props = {
  isLoading: boolean;

  /** Temporary flag to allow signup to hide this for now @TODO */
  signupVariant?: boolean;
  onCancel?: () => void;
  onForgotPassword?: () => void;
};

export const LoginFormUi = ({ isLoading, signupVariant = false, onCancel, onForgotPassword }: Props): JSX.Element => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <FormLayout.Fields>
        <TextInput
          {...register('email')}
          data-testid="form-log-in-email"
          autoFocus
          label={t('login.form.fields.email')}
        />
        <PasswordInput
          {...register('password')}
          data-testid="form-log-in-password"
          name="password"
          label={t('login.form.fields.password')}
        />

        {!onForgotPassword && (
          <Link to="resetPassword">
            <Button data-testid="form-forgot-password-button" disabled={isLoading} variant="link" size="md">
              {t('login.form.forgotPassword')}
            </Button>
          </Link>
        )}

        {onForgotPassword && (
          <Button
            data-testid="form-forgot-password-button"
            disabled={isLoading}
            variant="link"
            size="md"
            onClick={onForgotPassword}
          >
            {t('login.form.forgotPassword')}
          </Button>
        )}
      </FormLayout.Fields>

      <FormLayout.GlobalErrors message={errors.root?.message} />

      <FormLayout.CTA>
        <SubmitButton data-testid="form-log-in-button" size="lg" fullWidth={!signupVariant}>
          {t('login.form.submit')}
        </SubmitButton>
        {onCancel && (
          <Button
            data-testid="form-log-in-cancel-button"
            size="lg"
            variant="secondary"
            fullWidth={!signupVariant}
            onClick={onCancel}
          >
            {t('login.form.cancel')}
          </Button>
        )}
      </FormLayout.CTA>
    </>
  );
};
